import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../context/UserContext";

const ProtectedRoute = ({ children }) => {
  const { user } = useUser();

  if (!user) {
    // Redireciona para o login se o usuário não estiver logado
    return <Navigate to="/login" />;
  }

  // Renderiza o conteúdo se o usuário estiver autenticado
  return children;
};

export default ProtectedRoute;
